/**
 * DEM-specific configuration for Home Page
 *
 * Extends default configuration with DEM-specific customizations
 */

// Import DEM-specific images
import backgroundImage from 'assets/images/dem/dashboard-bg-1.jpg';
import logoImage from 'assets/images/dem/dem-icon.png';

export const demHomeConfig = {
  welcomeMessage: 'Welcome to DEM Analytics',
  subtitle: 'Transform your restaurant data into actionable insights',
  bodyMessage: 'Explore your data analytics and business intelligence tools.',
  futurePhaseNote: 'Customizable dashboards and predictive analytics launching soon',
  headerBg: backgroundImage,
  logo: logoImage,
};

export default demHomeConfig;
